<template>
  <div class="container">
    <div v-if="ferramentas.maisAcessados.length > 0">
      <h3 class="mb-4 mt-4">Mais Acessados</h3>
      <carousel :dots="true" ref="carouselMaisAcessados">
        <carousel-item v-for="(item, index) in ferramentas.maisAcessados"
          :key="item.id + '-' + index"
          :titulo="item.titulo"
          :imagem="cursoImagem(item.imagem)"
          :tipo="item.tipo"
          :url="item.url"
          :id="item.id"
          :texto-url="txtAbrir(item.tipo)"
          :disciplina="item.nome_disciplina"
          :curso="item.nome_curso"
        />
      </carousel>
    </div>

    <div v-if="ferramentas.modelos3D.length > 0 && (ferramenta === null || ferramenta === 'modelos-3d')">
      <div class="d-flex align-items-center justify-content-between w-100">
        <h3 class="mb-4 mt-4">Modelos 3D</h3>
        <div class="ver-todas-ferramentas" v-if="!ferramenta">
          <a @click="$emit('alterna-ferramenta', 'modelos-3d')">VER TODOS</a>
        </div>
      </div>
      <carousel :dots="false" ref="carouselModelos3d">
        <carousel-item v-for="(modelo, index) in ferramentas.modelos3D"
          :key="modelo.id + '-' + index"
          :titulo="modelo.topico.topico"
          :imagem="cursoImagem(modelo.curso.imagens[0].url)"
          :tipo="'modelo3d'"
          :url="urlTopico(modelo)"
          :texto-url="txtAbrir('modelo3d')"
          :disciplina="modelo.nome_disciplina"
          :curso="modelo.nome_curso"
        />
      </carousel>
    </div>

    <div v-if="ferramentas.mapas.length > 0 && (ferramenta === null || ferramenta === 'mapas-mentais')">
      <div class="d-flex align-items-center justify-content-between w-100">
        <h3 class="mb-4 mt-4">Mapas Mentais</h3>
        <div class="ver-todas-ferramentas" v-if="!ferramenta">
          <a @click="$emit('alterna-ferramenta', 'mapas-mentais')">VER TODOS</a>
        </div>
      </div>
      <carousel :dots="false" ref="carouselMapasMentais">
        <carousel-item v-for="(mapa, index) in ferramentas.mapas"
          :key="mapa.id + '-' + index"
          :titulo="mapa.topico.topico"
          :imagem="cursoImagem(mapa.curso.imagens[0].url)"
          :tipo="'mapa'"
          :url="urlTopico(mapa)"
          :texto-url="txtAbrir('mapa')"
          :disciplina="mapa.nome_disciplina"
          :curso="mapa.nome_curso"
        />
      </carousel>
    </div>

    <div v-if="ferramentas.resumos.length > 0 && (ferramenta === null || ferramenta === 'resumos')" class="mb-4">
      <div class="d-flex align-items-center justify-content-between w-100">
        <h3 class="mb-4 mt-4">Resumos</h3>
        <div class="ver-todas-ferramentas" v-if="!ferramenta">
          <a @click="$emit('alterna-ferramenta', 'resumos')">VER TODOS</a>
        </div>
      </div>
      <carousel :dots="false" ref="carouselResumos">
        <carousel-item v-for="(resumo, index) in ferramentas.resumos"
          :key="resumo.id + '-' + index"
          :titulo="resumo.titulo"
          :imagem="cursoImagem(resumo.modulos[0].cursos[0].imagens[0].url)"
          :tipo="'resumo'"
          :url="resumo.url"
          :id="resumo.id"
          :texto-url="txtAbrir('resumo')"
          :disciplina="resumo.nome_disciplina"
          :curso="resumo.nome_curso"
        />
      </carousel>
    </div>
  </div>
</template>

<script>
import Carousel from '@/core/components/Carousel'
import CarouselItem from './CarouselItem'
export default {
  name: 'FerramentasCarousel',
  components: {
    Carousel,
    CarouselItem
  },
  props: {
    ferramentas: Object,
    ferramenta: String
  },
  mounted () {
    this.applyOwlCarousel()
  },
  methods: {
    applyOwlCarousel: function () {
      if (this.ferramentas.resumos.length > 0 && (this.ferramenta === null || this.ferramenta === 'resumos')) {
        this.$refs.carouselResumos.applyOwlCarousel()
      }
      if (this.ferramentas.modelos3D.length > 0 && (this.ferramenta === null || this.ferramenta === 'modelos-3d')) {
        this.$refs.carouselModelos3d.applyOwlCarousel()
      }
      if (this.ferramentas.mapas.length > 0 && (this.ferramenta === null || this.ferramenta === 'mapas-mentais')) {
        this.$refs.carouselMapasMentais.applyOwlCarousel()
      }
      if (this.ferramentas.maisAcessados.length > 0) {
        this.$refs.carouselMaisAcessados.applyOwlCarousel()
      }
    },
    cursoImagem (url) {
      if (url.includes('cursos-plataforma')) {
        return url
      } else {
        return 'cursos-plataforma/' + url
      }
    },
    urlTopico (ementa) {
      return 'sala-de-aula/' + ementa.curso.referencia + '/' + ementa.modulo.referencia + '/' + ementa.licao.referencia + '/' + ementa.topico.referencia
    },
    txtAbrir (tipo) {
      switch (tipo) {
        case 'resumo':
          return 'Abrir Resumo'
        case 'mapa':
          return 'Abrir Mapa Mental'
        case 'modelo3d':
          return 'Abrir Modelo 3D'
        default:
          return 'Abrir'
      }
    }
  }
}
</script>
